export const superAdminDashboard = {
    title: "Super Admin Dashboard",
    appContent: "App Content",
    organisational: "Organisational",
    appContentDescription: "Manage projects, content, users, and app-level features",
    organisationalDescription: "Manage organisational features, partnerships, and high-level operations",
    backToDashboard: "Back to Dashboard",
    dashboard: "Dashboard",
    app: "App",
    organisation: "Organisation",
    workspaceSwitcher: "Workspace",
    allCards: "All cards",
}
